import angular from 'angular';
import subcontractorsComponent from './subcontractors.component';

let subcontractorsModule = angular.module('subcontractors', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('subcontractors', subcontractorsComponent);

export default subcontractorsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontractors/subcontractors.js